export default __webpack_public_path__ + "static/3-4df74fd9ec516dc6dcecc74e36aa67a1.png";